// extracted by mini-css-extract-plugin
export default {"root":"Auth_root__+4nrn","error":"Auth_error__2cPIJ","button":"Auth_button__yIJnu","selectLang":"Auth_selectLang__siqxB","input":"Auth_input__TaELr"};